module.exports = __webpack_public_path__ + "img/timeware.a032b5d3.svg";